import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry() {
	if (!import.meta.env.VITE_SENTRY_DSN) {
		return;
	}

	if (initialized) {
		return Sentry;
	}

	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration()
		],
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Session Replay
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 0,
		initialScope: {
			tags: { deviceMemory: navigator?.deviceMemory || 'NA' }
		},
		ignoreErrors: [
			'TypeError: Failed to fetch',
			'TypeError: Load failed',
			'TypeError: NetworkError when attempting to fetch resource.',
			'TypeError: cancelled'
		]
	});

	initialized = true;

	return Sentry;
}
